import { firestore } from "../../firebase/configure";
import { COLLECTIONS } from "../../constants/enums";

export const getActivityByFunnelId = (id: string) =>
    firestore
        .collection(COLLECTIONS.ACTIVITY)
        .where("funnelId", "==", id)
        .orderBy("createTime", "asc");
